import { useClone } from '@wap-client/core'

import Anchor from '../anchor'

import type { BreadcrumbItemProps } from './types'

export const BreadcrumbsItem: React.FunctionComponent<BreadcrumbItemProps> = ({
  children,
  href,
  iconAfter,
  iconBefore,
}) => {
  const iconBeforeElem = useClone(iconBefore, {
    size: iconBefore?.props.size || 'small',
  })

  const iconAfterElem = useClone(iconAfter, {
    size: iconBefore?.props.size || 'small',
  })

  if (href) {
    return (
      <li className="breadcrumb__item">
        <Anchor href={href} className="breadcrumb__anchor">
          {iconBeforeElem}
          {children && (
            <span className="breadcrumb__anchor-text">{children}</span>
          )}
          {iconAfterElem}
        </Anchor>
      </li>
    )
  }

  return (
    <li className="breadcrumb__item">
      {iconBeforeElem}
      {children && <span className="breadcrumb__anchor-text">{children}</span>}
      {iconAfterElem}
    </li>
  )
}

export default BreadcrumbsItem
